import { TableCell, TableHead, TableRow } from "@mui/material";

export default function SettlementPaymentsTableHeader({ showActions = true }) {
  return (
    <TableHead>
      <TableRow>
        <TableCell align="center">&nbsp;</TableCell>
        <TableCell className="font-bold">Type</TableCell>
        <TableCell className="font-bold">From</TableCell>
        <TableCell className="font-bold">To</TableCell>
        {showActions ? (
          <TableCell className="font-bold" align="right">
            &nbsp;
          </TableCell>
        ) : null}
      </TableRow>
    </TableHead>
  );
}

